import Styles from './CustomCard.module.css'
export default function CustomCard(props:any){
        return(<div className={`${Styles.card} ${props.className}`}>{props.children}</div>)

}